module.exports = __webpack_public_path__ + "static/media/Flow-WooCommerce-2.71ef58b0.png";